<template>
    <div class="me-3 fw-bold">
        {{ completedBadgeText }}
    </div>
</template>
<script>
    import { KEYS, NAMESPACE } from "Forms/Components/Elements/i18n/eSignature.i18n";
    export default {
        computed: {
            completedBadgeText() {
                return this.$app.res({ namespace: NAMESPACE, key: KEYS.completedBadgeText });
            }
        }
    };
</script>
